// l10n status: not applicable
console.debug("LOADING l10n")
// MTVW-435
import { mapKeys, camelCase } from "lodash"
import { printf } from "fast-printf"
import { appFeatures } from "../../AppFeatures"
import { rootStore } from "store/RootStore"
import { flow, observable, runInAction } from "mobx"

export var l10n = observable({})

export const setLanguage = flow(function* (lang) {
   //export async function setLanguage(lang) {
	try {
		const response = yield fetch(`${lang}.json`)
		let data = yield response.json()
		const _l10n = yield mapKeys(data, (value, key) => camelCase(key))
		runInAction(() => {
			l10n = _l10n
			// make sure current language is used in search page
			rootStore?.page?.Search?.setupLanguageStrings()
		})
		//console.debug("L10n data %o, %o", l10n, l10n.featurePinRecoveryNewPinEmail)
		//mytest()
	}
	catch (e) {
		// TODO: add fallback object or reload app?
		console.error("ERROR in setLanguage %o", e)
		appFeatures.persistedLanguage = "de"
		const response = yield fetch(`de.json`)
		let data = yield response.json()
		const _l10n = yield mapKeys(data, (value, key) => camelCase(key))
		runInAction(() => {
			l10n = _l10n
			// make sure current language is used in search page
			rootStore?.page?.Search?.setupLanguageStrings()
		})
	}
})

// eslint-disable-next-line no-extend-native
String.prototype.format = function () {
   return arguments?.length === 0 ? this : printf(this, ...arguments)
}

/*
function mytest() {
   console.debug("PLACEHOLDERS Test %s", l10n.featurePinRecoveryNewPinEmailWithChangeLink.format("User", "Ivo", "Ivo", "1234"))
   console.debug("EMPTY %s", "Nothing in this string".format())
}
*/
